<div class="sidebar relative duration-200 overflow-hidden h-full shadow-lg"
     [ngClass]="{open: opened}"
     [ngStyle]="{'max-width': opened ? config.width : config.closedWidth}">
    <button class="cmn-button text-left"
            (click)="toggle()">
        <span class="icon {{config.toggle.iconClass}}">{{ config.toggle.icon }}</span>
        {{ config.toggle.text }}
    </button>
    <div class="overflow-auto flex flex-col h-full"
         [ngStyle]="{width: config.width}">
        <ng-content select=".side"></ng-content>
    </div>

</div>
<div class="flex-1 overflow-auto px-4 my-4" cdkScrollable>
    <ng-content select=".content"></ng-content>
</div>
